import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M15.993 15.285c2.665-3.017 2.665-7.554 0-10.571l.018-.018-.707-.707-.018.018c-3.017-2.665-7.554-2.665-10.571 0l-.018-.018-.707.707.018.018c-2.665 3.017-2.665 7.554 0 10.571l-.018.018.707.707.018-.018c3.017 2.665 7.554 2.665 10.571 0l.018.018.707-.707-.018-.018zm-.708-.707L10.707 10l4.578-4.578c2.273 2.621 2.273 6.535 0 9.157zm-.707-9.863L10 9.293 5.422 4.715c2.621-2.273 6.535-2.273 9.157 0zm-9.863.707L9.293 10l-4.578 4.578c-2.273-2.621-2.273-6.535 0-9.157zm.707 9.863L10 10.707l4.578 4.578c-2.621 2.273-6.535 2.273-9.157 0z',
  ],
  height: 20,
  width: 20,
});
